export default {"src":"/_next/static/media/header_icon_group2.422a3945.svg","height":223,"width":172,"blurWidth":0,"blurHeight":0};